import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ReservarPage from './pages/ReservarPage.js';
import ConsultaPage from './pages/ConsultaPage.js';
import QueuePage from './pages/QueuePage.js';
import BrandHeader from './components/BrandHeader.js';
import { useTenantBranding } from './lib/branding.js';

const PRODUCTS = [
  { id: '1', name: 'Taco de Pastor', price: 2500, category: 'Tacos', img: '🌮' },
  { id: '2', name: 'Enchiladas Verdes', price: 8900, category: 'Platos', img: '🫔' },
  { id: '3', name: 'Agua de Horchata', price: 2000, category: 'Bebidas', img: '🥤' },
  { id: '4', name: 'Pozole Rojo', price: 12000, category: 'Platos', img: '🍲' },
  { id: '5', name: 'Quesadilla', price: 5500, category: 'Antojitos', img: '🧀' },
  { id: '6', name: 'Mezcal Artesanal', price: 9500, category: 'Bebidas', img: '🥃' },
];

function formatMXN(cents: number) {
  return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cents / 100);
}

function Catalog() {
  const [cart, setCart] = React.useState<string[]>([]);
  // Catálogo demo no tiene tenantId en URL → fallback NintaiGO.
  const branding = useTenantBranding(null);

  return (
    <div className="sf-page">
      <BrandHeader
        branding={branding}
        right={
          <div className="sf-topbar__cart">
            <span aria-label="carrito">🛒</span>
            <span>{cart.length}</span>
          </div>
        }
      />
      <div className="sf-container">
        <h1 className="sf-h1">Menú</h1>
        <div className="sf-grid">
          {PRODUCTS.map((p) => (
            <article key={p.id} className="sf-product">
              <div className="sf-product__media" aria-hidden="true">
                {p.img}
              </div>
              <div className="sf-product__body">
                <div className="sf-product__category">{p.category}</div>
                <div className="sf-product__name">{p.name}</div>
                <div className="sf-product__row">
                  <span className="sf-product__price">{formatMXN(p.price)}</span>
                  <button
                    type="button"
                    className="sf-btn-add"
                    onClick={() => setCart((c) => [...c, p.id])}
                  >
                    + Agregar
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      {/* :tenantId acepta UUID o slug (ReservarPage resuelve slug→tenantId). */}
      <Route path="/reservar/:tenantId" element={<ReservarPage />} />
      {/* Stream 3 Fase 1 Super Plan — consulta pública por código. */}
      <Route path="/consulta/:tenantSlug" element={<ConsultaPage />} />
      {/* Lane #163 — fila de espera pública. Canónico: fila.nintaigo.com/<slug>
          ("queue" en inglés no se entiende). /queue se mantiene como alias. */}
      <Route path="/fila/:tenantSlug" element={<QueuePage />} />
      <Route path="/queue/:tenantSlug" element={<QueuePage />} />
      <Route path="/*" element={<Catalog />} />
    </Routes>
  );
}
